<template>
    <fragment>
        <input
            v-show="showString"
            ref="inputMoneyString"
            v-model="priceString"
            type="text"
            class="app-textarea mt-2 lg:text-3xl md:text-2xl text-xl text-theme-base w-full background-success"
            :disabled="!enabled"
            @focus="onFocus"
        />
        <input
            v-show="!showString"
            ref="inputMoneyNumber"
            v-model="priceNumber"
            type="text"
            class="app-textarea mt-2 lg:text-3xl md:text-2xl text-xl text-theme-base w-full background-success"
            @blur="onBlur"
            @input="onInput"
            @keyup.enter="onEnter"
        />
    </fragment>
</template>

<script>
import { mapGetters } from "vuex";

import { parseMoneyShorthand, sanitizeMoneyInput } from "@/common/lib/money";

export default {
    name: "InputMoneyComponent2",
    model: {
        prop: "itemCurrent",
        event: "input"
    },
    props: {
        itemCurrent: {
            default: 0,
            type: Number,
            required: true,
            nullable: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        autofocus: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    emits: ["input", "blur", "enter"],
    data: () => ({
        priceString: "",
        priceNumber: "",
        showString: true
    }),
    computed: {
        ...mapGetters("control", ["stateInputDark"]),
        stateEnabled() {
            return this.enabled ? this.stateInputDark : "";
        }
    },
    watch: {
        itemCurrent(value) {
            if (!this.showString) return;
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
        if (this.autofocus) {
            this.showString = false;
            setTimeout(() => {
                this.$refs.inputMoneyNumber.focus();
            }, 100);
        }
    },
    methods: {
        onFocus() {
            this.showString = false;
            setTimeout(() => {
                this.$refs.inputMoneyNumber.focus();
            }, 100);
            this.$emit("focus");
        },
        onBlur() {
            this.formatPrice();
            this.showString = true;
            this.$emit("blur");
        },
        onEnter() {
            this.formatPrice();
            this.showString = true;
            this.$emit("enter");
        },

        onInput() {
            this.$emit("input", this.formatPrice());
        },
        formatPrice() {
            this.priceNumber = sanitizeMoneyInput(this.priceNumber);
            const numericValue = parseMoneyShorthand(this.priceNumber);
            this.priceString = this.$options.filters.currency(numericValue);
            return numericValue;
        },
        setInput(value) {
            this.priceNumber = String(value || 0);
            this.priceString = this.$options.filters.currency(value);
        }
    }
};
</script>
